// extracted by mini-css-extract-plugin
module.exports = {"PresentationPdf":"PresentationPdf_PresentationPdf__2D4H_","Pdf":"PresentationPdf_Pdf__rbBsj","Link":"PresentationPdf_Link__3Mw08"};